<template>
  <div id="avatar" >
    <div>
      <v-breadcrumbs :items="breadcrumbs" >
        <v-icon slot="divider" >forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
       <base-material-card
                          color="primary"
                          icon="library_books"
                          title="Editar Perfil"
                          class="px-5 py-3"
                        >
            <v-card-actions>
             
                
              <v-spacer></v-spacer>
            </v-card-actions>

            <v-card-text>
              <h4>{{ this.email }}</h4>

              <my-upload
                field="imagen"
                @crop-success="cropSuccess"
                v-model="show"
                :width="128"
                :height="128"
                langType="es-MX"
                :headers="headers"
                :params="params"
                img-format="png"
              />
              <v-flex
                xs12
                sm6
                md8
                align-center
                justify-center
                layout
                text-xs-center
              >
                <v-avatar title size="128" color="grey lighten-4" >
                  <img :src="imgDataUrl" />
                </v-avatar>
              </v-flex>

              <v-flex
                xs12
                sm6
                md8
                align-center
                justify-center
                layout
                text-xs-center
              >
                <v-btn
                  @click.native="toggleShow"
                  title="Actualizar Imagen"
                  v-tippy
                >
                  <v-icon dark>picture_in_picture</v-icon> Actualizar Foto de
                  Perfil
                </v-btn>
              </v-flex>
            </v-card-text>
          </base-material-card> 
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";

import axios from "axios";

export default {
  created: function() {
    this.email = this.$local_storage.get("email");
    this.urlget = this.$hostname + "avatar/get_avatar/";
    this.urlpost = this.$hostname + "avatar/save_avatar/";
    this.imgDataUrl = this.$local_storage.get("avatar");
    // this.carga();
  },
  data: () => ({ fab: false,
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Editar Perfil",
        disabled: true,
        to: ""
      }
    ],
    params: {
      email: ""
    },
    email: "",
    show: false,
    userAvatar: undefined,
    urlget: "",
    urlpost: "",
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      "cache-control": "no-cache"
    },
    imgDataUrl: "", // the datebase64 url of created image
    labels: { submit: "Subir", cancel: "Cancelar" }
  }),
  components: {
    "my-upload": myUpload,
    
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },

    decode: function(file) {
      var binaryString = window.atob(file);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    carga() {
      var data = {
        email: this.email,
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };
      axios
        .post(this.urlget, data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.imgDataUrl = res.data.avatar;
            this.$local_storage.set("avatar", res.data.avatar);
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    send: function(file) {
      //const config = { headers: { "Content-Type": "multipart/form-data" } };
      /*let formData = new FormData();
      formData.append("imagen", file);
      formData.append("email", this.email);*/

      let formData = {
            imagen: this.file,
            email: this.email,
          };

      let self = this;

      axios
        .post(this.urlpost, formData)
        .then(function(response) {
          self.$swal({
            type: "success",
            title: "Operación Existosa",
            text: response.data.mensaje,
            footer: ""
          });
        })
        .catch(function(error) {
          var msg =
            "Ocurrió un error al actualizar la imagen, vuelva intentarlo";
          console.log(error);
          if (error.response.data.mensaje) {
            self.$swal({
              type: "error",
              title: "Operación No Valida",
              text: error.response.data.mensaje[0],
              footer: ""
            });
          } else {
            self.$swal({
              type: "error",
              title: "Datos no Válidos",
              text: msg,
              footer: ""
            });
          }
        });
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
      this.$local_storage.set("avatar", imgDataUrl);
      this.$root.$emit("cambiaravatar", imgDataUrl);
      //const config = { headers: { "Content-Type": "multipart/form-data" } };
      
      /*let formData = new FormData();
      formData.append("imagen", imgDataUrl);
      formData.append("email", this.email);*/

      let formData = {
            imagen: imgDataUrl,
            email: this.email,
          };
      
      let self = this;

      axios
        .post(this.urlpost, formData)
        .then(function(response) {
          self.$swal({
            type: "success",
            title: "Operación Existosa",
            text: response.data.mensaje,
            footer: ""
          });
        })
        .catch(function(error) {
          var msg =
            "Ocurrió un error al actualizar la imagen, vuelva intentarlo";
          console.log(error);
          if (error.response.data.mensaje) {
            self.$swal({
              type: "error",
              title: "Operación No Valida",
              text: error.response.data.mensaje[0],
              footer: ""
            });
          } else {
            self.$swal({
              type: "error",
              title: "Datos no Válidos",
              text: msg,
              footer: ""
            });
          }
        });
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    }
  }
};
</script>
